const NAME_MESSAGES: Record<string, string> = {
  NotAuthorizedException: 'Incorrect email or password.',
  UserNotFoundException: 'Incorrect email or password.',
  UsernameExistsException: 'An account with that email already exists. Try signing in.',
  InvalidPasswordException:
    'Use at least 10 characters, including uppercase, lowercase, a number, and a symbol.',
  InvalidParameterException: 'Please check what you entered and try again.',
  CodeMismatchException: 'That confirmation code is incorrect.',
  ExpiredCodeException: 'That code has expired. Request a new one.',
  LimitExceededException: 'Too many attempts. Please wait a few minutes and try again.',
  TooManyRequestsException: 'Too many attempts. Please wait a few minutes and try again.',
  UserNotConfirmedException: 'Confirm your email with the code we sent you, then sign in.',
  CodeDeliveryFailureException: 'We could not send email just now. Please try again shortly.',
};

function messageFromName(name: string | undefined): string | undefined {
  if (!name) return undefined;
  return NAME_MESSAGES[name];
}

function looksLikeInternalError(message: string): boolean {
  return (
    /API URL not configured/i.test(message) ||
    /config\.json/i.test(message) ||
    /BLOCKS_API_URL/i.test(message) ||
    /npm run deploy/i.test(message) ||
    /SSR Lambda/i.test(message) ||
    /Cognito/i.test(message) ||
    /Lambda/i.test(message)
  );
}

export function toUserAuthMessage(
  err: unknown,
  fallback = 'Something went wrong. Please try again.'
): string {
  if (err && typeof err === 'object') {
    const rec = err as { errorName?: string; error?: string; name?: string; message?: string };
    const named = messageFromName(rec.errorName) || messageFromName(rec.name);
    if (named) return named;
    const raw = rec.error || rec.message;
    if (typeof raw === 'string' && raw.trim()) {
      const fromRawName = messageFromName(raw.trim());
      if (fromRawName) return fromRawName;
      if (looksLikeInternalError(raw)) {
        return 'We could not reach the game servers. Please try again in a moment.';
      }
      if (/failed to fetch|networkerror|load failed/i.test(raw)) {
        return 'We could not reach the game servers. Check your connection and try again.';
      }
      if (!looksLikeInternalError(raw) && raw.length < 180) {
        return raw;
      }
    }
  }
  if (err instanceof Error && looksLikeInternalError(err.message)) {
    return 'We could not reach the game servers. Please try again in a moment.';
  }
  return fallback;
}
